import { render, staticRenderFns } from "./RotateSquare2.vue?vue&type=template&id=3aa4189b&scoped=true&"
import script from "./RotateSquare2.vue?vue&type=script&lang=js&"
export * from "./RotateSquare2.vue?vue&type=script&lang=js&"
import style0 from "./RotateSquare2.vue?vue&type=style&index=0&id=3aa4189b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa4189b",
  null
  
)

export default component.exports